import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import MultiselectComponent from "../components/MultiselectComponent";
import {
  getOutputColumnsData,
  getMappings,
  saveAsMappings,
  getInputColumnsData,
  getEditStateData,
  getChangesFlag,
  setunSavedRulesChanges,
} from "../store/workspaceSlice";
import DropDownMenu from "../components/DropDownMenu";
import Button from "../components/Button";
import { rulesProperties, allowedRules, showAddedRulesToast } from "../helpers";
import CheckBox from "../components/CheckBox";
const initialObjectProperties = {
  appliedRule: 4,
  useOutputOf: null,
  output: null,
  switchColMappings: {},
  inputColumns: [],
  outputColumns: [],
};

const SwitchColumnPage = () => {
  const dispatch = useDispatch();
  const [switchObject, setswitchObject] = useState(initialObjectProperties);
  const [selectInputcols, setselectInputcols] = useState();
  const [selectOutputCols, setselectOutputCols] = useState();
  const outputColsData = useSelector(getOutputColumnsData);
  const inputColsData = useSelector(getInputColumnsData);
  const currentMaps = useSelector(getMappings);
  const state = useSelector(getEditStateData);
  const [isInLocalEditMode, setIsInLocalEditMode] = useState(false);
  const USfalg = useSelector(getChangesFlag); // unsaved changes flag

  useEffect(() => {
    if (state?.type === "swt") {
      setswitchObject((prev) => ({ ...prev, ...state.data }));
      setselectInputcols(
        state.data.inputColumns.map((item) => ({
          label: item,
          value: item,
        }))
      );
      setselectOutputCols(
        state.data.outputColumns.map((item) => ({
          label: item,
          value: item,
        }))
      );
      setIsInLocalEditMode(true);
    }
  }, [state?.data, state.type, state?.data?._id]);

  const handlesetselectInputcols = (selectedOptions) => {
    setselectInputcols(selectedOptions);
    setswitchObject({
      ...switchObject,
      inputColumns: selectedOptions.map((sel) => sel.value),
    });
    helperFunction();
  };

  const handlesetselectOutputCols = (selectedOptions) => {
    setselectOutputCols(selectedOptions);
    setswitchObject({
      ...switchObject,
      outputColumns: selectedOptions.map((sel) => sel.value),
    });
    helperFunction();
  };

  const handleOnChange = (e) => {
    setswitchObject((prev) => {
      return {
        ...prev,
        [e.target.name]: e.target.value,
      };
    });
    helperFunction();
  };

  const helperFunction = () => {
    if (!USfalg) {
      dispatch(setunSavedRulesChanges(true));
    }
  };

  const handleAddNewRule = () => {
    // Cleaning mappings data
    const cleanedMappings = Object.fromEntries(
      Object.entries(switchObject?.switchColMappings).filter(([key]) =>
        switchObject?.inputColumns.includes(key)
      )
    );
    const updatedSwitchObject = {
      ...switchObject,
      switchColMappings: cleanedMappings,
    };

    dispatch(
      saveAsMappings({
        ...updatedSwitchObject,
      })
    );
    showAddedRulesToast(
      switchObject.appliedRule,
      isInLocalEditMode ? "Updated" : "added"
    ); // Show toast notification
    reset();
  };

  const reset = () => {
    setswitchObject(initialObjectProperties);
    setselectInputcols("");
    setselectOutputCols("");
    setIsInLocalEditMode(true);
  };
  return (
    <>
      <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-4 p-2">
        <MultiselectComponent
          options={inputColsData.map((item) => ({
            label: item.inColChr,
            value: item.inColChr,
          }))}
          selectedOptions={selectInputcols}
          handleSetSelect={handlesetselectInputcols} // Handle the selection change
          label={"Select Input Columns"}
          required={true}
        />
        <MultiselectComponent
          options={outputColsData.map((item) => ({
            label: item.outColChr,
            value: item.outColChr,
          }))}
          selectedOptions={selectOutputCols}
          handleSetSelect={handlesetselectOutputCols} // Handle the selection change
          label={"Select Output Columns"}
          required={true}
        />{" "}
        <DropDownMenu
          label={"Use Output of previous Rule"}
          name="useOutputOf"
          value={switchObject.useOutputOf || ""}
          options={currentMaps
            .filter((item) => allowedRules.includes(item.appliedRule)) // Filter items based on allowed rules
            .map((item) => ({
              label: `${item._id} :  ${
                item.appliedRule
                  ? rulesProperties[item?.appliedRule].ruleName
                  : item.ruleName
              }`,
              value: parseInt(item._id),
            }))}
          onChange={handleOnChange}
          required={true}
          placeholder={"Select previous rule output"}
        />
        {switchObject.outputColumns.length === 1 &&
          switchObject.inputColumns.length >= 1 && (
            <div className="col-span-2 flex justify-start items-end gap-x-8">
              <div className="min-h-10 flex">
                <CheckBox
                  name={"sameAsOutput"}
                  chkBoxText={"Same as output column"}
                  onChange={(e) => {
                    if (e.target.checked) {
                      setswitchObject((prevState) => ({
                        ...prevState,
                        switchColMappings: Object.fromEntries(
                          Object.values(prevState.inputColumns).map(
                            (key) => [key, switchObject.outputColumns[0]] // 0 because will work if only one output column is selected
                          )
                        ),
                      }));
                    }
                  }}
                />
              </div>
            </div>
          )}
        {switchObject.outputColumns?.length > 0 &&
          switchObject.inputColumns?.length > 0 && (
            <div className="col-span-2 w-full p-2">
              <label className="font-semibold">
                Map switch columns to output column
              </label>

              <div className="grid grid-cols-1 xl:grid-cols-2 gap-4 mt-2">
                {switchObject.inputColumns.map((column) => (
                  <DropDownMenu
                    key={column}
                    label={column}
                    name={column}
                    required={true}
                    value={switchObject.switchColMappings[column] || ""}
                    options={switchObject.outputColumns.map((col) => ({
                      label: col,
                      value: col,
                    }))}
                    onChange={(e) => {
                      // Update the switchColMappings state
                      setswitchObject((prevState) => ({
                        ...prevState,
                        switchColMappings: {
                          ...prevState.switchColMappings,
                          [column]: e.target.value || "",
                        },
                      }));
                    }}
                  />
                ))}
              </div>
            </div>
          )}
        <div className="flex gap-4 w-full col-span-2">
          <Button
            disabled={
              switchObject.inputColumns.length === 0 ||
              switchObject.outputColumns.length === 0 ||
              !switchObject.useOutputOf
            }
            btnText={`${isInLocalEditMode ? "Update" : "Save"}`}
            handleOnClick={handleAddNewRule}
            // disabled={!(switchObject.inputColumn && switchObject.outputColumn)}
          />
          <Button
            btnType="cancel"
            // disabled={} // Disable the button if there are no character codes
            btnText={"Reset"}
            handleOnClick={() => reset()}
          />
        </div>
      </div>
    </>
  );
};

export default SwitchColumnPage;
